import gql from 'graphql-tag';
import { pageInfoFragment } from '../fragments/page-info.fragment';
import { lightUserFragment } from '../fragments/light-user.fragment';

export const searchUsersQuery = gql`
  query searchUsers(
    $nameOrHandleContains: String!
    $areFollowers: Boolean
    $limit: Int
    $after: ID
  ) {
    searchUsers(
      nameOrHandleContains: $nameOrHandleContains
      areFollowers: $areFollowers
      limit: $limit
      after: $after
    ) {
      data {
        ...lightUserFragment
      }
      pageInfo {
        ...pageInfoFragment
      }
    }
  }
  ${pageInfoFragment}
  ${lightUserFragment}
`;
